import { Injectable, inject, OnDestroy } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AdminAuthStateService } from '../auth/auth.service';
import { PermissionService } from './permission.service';
import { AdminNotificationService } from './admin-notification.service';

/** Polls permissions + validates session when WebSocket events are missed. */
@Injectable({ providedIn: 'root' })
export class AdminRbacLiveSyncService implements OnDestroy {
  private readonly authState = inject(AdminAuthStateService);
  private readonly permissionService = inject(PermissionService);
  private readonly notificationService = inject(AdminNotificationService);

  private pollSub?: Subscription;
  private readonly pollIntervalMs = 15_000;

  start(): void {
    if (!this.authState.getToken()) {
      return;
    }
    this.notificationService.init();
    this.stop();
    this.pollSub = timer(this.pollIntervalMs, this.pollIntervalMs)
      .pipe(switchMap(() => this.permissionService.refreshPermissions()))
      .subscribe();
  }

  stop(): void {
    this.pollSub?.unsubscribe();
    this.pollSub = undefined;
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
